import { useEffect } from "react";
import { CONTACT } from "../lib/data";
import Seo from "../components/Seo";

export default function Impressum() {
  useEffect(() => { window.scrollTo({ top: 0 }); }, []);
  return (
    <main data-testid="impressum-page" className="pt-32 md:pt-40 pb-24 bg-[#F8F5EF] min-h-screen">
      <Seo title="Impressum" path="/impressum" noindex />
      <div className="container-x max-w-4xl">
        <div className="flex items-center gap-3 mb-6">
          
          <span className="overline">Rechtliches</span>
        </div>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#1A1A1A] tracking-tight">Impressum</h1>

        <section className="mt-12 space-y-8 text-[16px] leading-relaxed text-[#333] font-light">
          <div>
            <h2 className="font-display text-2xl text-[#1A1A1A] mb-3">Angaben gemäß § 5 TMG</h2>
            <p>
              {CONTACT.name}<br />
              handelnd unter der Geschäftsbezeichnung: Artur Bäcker Immobilien<br />
              Leistungsbereich / Marke: {CONTACT.brand}<br />
              {CONTACT.street}<br />
              {CONTACT.zip} {CONTACT.city}<br />
              {CONTACT.country}
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl text-[#1A1A1A] mb-3">Kontakt</h2>
            <p>
              Telefon: {CONTACT.phone}<br />
              Telefax: kein Fax<br />
              E-Mail: <a href={`mailto:${CONTACT.email}`} className="text-[#FFA500] hover:underline">{CONTACT.email}</a>
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl text-[#1A1A1A] mb-3">Umsatzsteuer-ID</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />DE354373156</p>
          </div>
          <div>
            <h2 className="font-display text-2xl text-[#1A1A1A] mb-3">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
          </div>
          <div>
            <h2 className="font-display text-2xl text-[#1A1A1A] mb-3">Urheberrecht und Bildnachweise</h2>
            <p>Die auf dieser Website veröffentlichten Inhalte, insbesondere Fotografien, unterliegen dem Schutz des Urheberrechtsgesetzes. Jede Nutzung, Vervielfältigung oder Verbreitung bedarf der vorherigen Zustimmung des jeweiligen Rechteinhabers, sofern nicht ausdrücklich etwas anderes vereinbart wurde.</p>
          </div>
          <div>
            <h2 className="font-display text-2xl text-[#1A1A1A] mb-3">Verantwortlich für journalistisch-redaktionelle Inhalte gemäß § 18 Abs. 2 MStV</h2>
            <p>{CONTACT.name}<br />{CONTACT.street}<br />{CONTACT.zip} {CONTACT.city}<br />{CONTACT.country}</p>
          </div>
        </section>
      </div>
    </main>
  );
}
